import EmbeddedEntryContainer from './EmbeddedEntryContainer'

export default EmbeddedEntryContainer
